module.exports = __webpack_public_path__ + "media/images/ic-search-9419b701f05503b5264df58a6ae4b3f0.svg";